export default __webpack_public_path__ + "static/media/Q22025.1972fb84.pdf";